import { EventrDate, useItinInfo } from '@eventr/common'
import {
    IFormBase,
    IIpInfo,
    TimezoneDropdown,
    useIpInfo,
} from '@eventr/common-storybook'
import { Controller } from 'react-hook-form'
import { useShallow } from 'zustand/react/shallow'
import { editItineraryFieldsTranslation } from '../../../i18n/translateHelpers'

interface ITimezoneSelectorFormProps extends IFormBase {
    required?: boolean
}

export const TimezoneSelectorForm = ({
    required,
    name,
    control,
}: ITimezoneSelectorFormProps) => {
    const ipInfo: IIpInfo = useIpInfo((s: any) => s.ipInfo)
    const { setTimeZone } = useItinInfo(
        useShallow((s) => {
            return {
                setTimeZone: s.setTimezone,
            }
        })
    )

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                const selectedDateTimeString = () => {
                    const newEventrDate = new EventrDate()
                    newEventrDate.setTimezone(
                        value ?? ipInfo?.timeZones?.[0] ?? 'Europe/London'
                    )

                    return newEventrDate.dateTimeString
                }
                return (
                    <div data-testid={name}>
                        <TimezoneDropdown
                            fieldLabel={
                                editItineraryFieldsTranslation('9') +
                                (required ? ' *' : '')
                            }
                            placeholder=""
                            defaultTZText=""
                            withOutItinDefaultOption
                            selectedDateTimeString={selectedDateTimeString()}
                            onChange={(tzObj) => {
                                onChange(tzObj?.obj.timezone)
                                setTimeZone(tzObj?.obj.timezone)
                            }}
                        />
                    </div>
                )
            }}
        ></Controller>
    )
}
